import clsx from 'clsx';

type Props = {
  required?: boolean;
  hasError?: boolean;
  tooltip?: React.ReactNode;
} & React.ComponentPropsWithoutRef<'label'>;

export function Label(props: Props) {
  const { className, required, hasError, children, tooltip, ...labelProps } =
    props;

  return (
    <label
      className={clsx(
        'flex items-center text-xs',
        hasError ? 'text-red-70' : 'text-grey-30',
        className
      )}
      {...labelProps}
    >
      <span className={clsx(required && "after:content-['*']")}>
        {children}
      </span>
      {tooltip && <span className="flex ml-1">{tooltip}</span>}
    </label>
  );
}
